import React from 'react';

/*
Example data format:
data = [                        <-- Contains list of texts
  {
    text: "some text"           <-- Text without bulletlist
  },
  {
    text: "some other text",
    list: [
      "list item 1",            <-- Shows bulletlist under "some other text"
      "list item 2",
      "list item 3"
    ]
  }
]

*/
export const NoteBox = ({data, theme}) => {

  let content = data.map((item, index) => {
    let bulletList;

    if(item.list){
      bulletList = (
        <BulletList
          list={ item.list || [] }
        />
      );
    }

    return(
      <div className="content" key={index}>
        {item.text}
        {bulletList}
      </div>
    );
  });

  return(
    <div className={"notice-box " + theme }>
      <div className="icon-container">
        <div className={"icon " +  theme + "-icon" }/>
      </div>
      {content}
    </div>
  );
};


const BulletList = ({list}) => {
  let listItems = list.map((item, index) => {
    return(
      <li key={index}>
        {item}
      </li>
    );
  });

  return(
    <ul>
      {listItems}
    </ul>
  );
};
